<div class="d-flex" id="wrapper">
  <app-sidebar [collapsed]="isSidebarCollapsed" (toggleSidebar)="toggleSidebar()"></app-sidebar>

  <div class="main-content flex-grow-1" [class.collapsed]="isSidebarCollapsed">
    <app-header class="layout-nav" (toggleSidebar)="toggleSidebar()"></app-header>

    <div class="container-fluid mt-3 p-3 content-area">
      <router-outlet></router-outlet>
    </div>
<app-loader></app-loader>
    <app-footer [class.collapsed]="isSidebarCollapsed"></app-footer>
  </div>
</div>

<app-notification-popup></app-notification-popup>
